import * as React from "react";

const AuthContext = React.createContext({
    user: {
        isLoggedIn: true,
        userid: "1",
        username: "gstylianop",
        userlevel: "moderate"
    },
    logginin: false,
    login: ( usename, password) => {},
    logout: ( ) => {},
    signin: ( email, username, password) => {}
})


function getInitialState() {
    const authdata = sessionStorage.getItem('myappuserinfo')
    return authdata ? JSON.parse(authdata) : {}
}

function AuthProvider({children}) {
    const [user, setUser] = React.useState(getInitialState())
    const [logginin, setLoginin] = React.useState(true)
    React.useEffect(() => {
        sessionStorage.setItem('myappuserinfo', JSON.stringify(user))
    },[user])
    const login = ( usename, password) => {
        let pseudouser = {
            isLoggedIn: true,
            userid: "1",
            username: "gstylianop",
            userlevel: "moderate"
        }
        setUser(pseudouser)
    }
    const logout = () => {
        let pseudouser = {
            isLoggedIn: true,
            userid: "1",
            username: "gstylianop",
            userlevel: "moderate"
        }
        setUser({})
    }
    const signin = ( email, username, password) => {

    }
    let value = { user, login, logout, signin };
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;         
}
function useAuth() {
    return React.useContext(AuthContext);
}

export {AuthProvider, AuthContext, useAuth}



